function primaryMenuControl() {
  return [...document.querySelectorAll('header-menu .menu-list__link,header-drawer summary.header__icon--menu')]
    .find(element => element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
}

function isMenuSkip(element) {
  return element instanceof Element && (element.matches('[data-skip-main-menu]')
    || element.matches('.accessibly-app-skip-link') && element.querySelector('[accessibly-app-i18n-key="skipToMenu"]'));
}

function skipToMenu(event) {
  const control = event.target instanceof Element
    ? event.target.closest('[data-skip-main-menu],.accessibly-app-skip-link') : null;
  if (!isMenuSkip(control)) return;
  if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
  const destination = primaryMenuControl();
  if (!destination) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  if (control.matches('.accessibly-app-skip-link')) {
    control.style.opacity = '0';
    control.style.pointerEvents = 'none';
    control.tabIndex = -1;
  }
  destination.focus();
}

document.addEventListener('keydown', skipToMenu, true);
document.addEventListener('click', skipToMenu, true);

document.addEventListener('keydown', event => {
  if (event.key !== 'Tab') return;
  const panel = document.querySelector('#accessiblyAppDialog:not([hidden])');
  if (!panel || panel.closest('[inert]') || !panel.getClientRects().length
    || getComputedStyle(panel).visibility === 'hidden') return;
  const controls = [...panel.querySelectorAll('button,a[href],input,select,textarea,[tabindex]')]
    .filter(element => element.tabIndex >= 0 && !element.matches(':disabled')
      && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
  const first = controls[0];
  const last = controls.at(-1);
  const active = document.activeElement;
  if (!first || !last || !panel.contains(active)) return;
  if (active === panel || event.shiftKey && active === first || !event.shiftKey && active === last) {
    event.preventDefault();
    event.stopImmediatePropagation();
    (event.shiftKey ? last : first)?.focus();
  }
}, true);

function replaceWithHeader(cell, scope, id) {
  const header = document.createElement('th');
  for (const attribute of cell.attributes) header.setAttribute(attribute.name, attribute.value);
  header.scope = scope;
  header.id = id;
  header.append(...cell.childNodes);
  cell.replaceWith(header);
  return header;
}

function enhanceSizeGuides() {
  const tables = document.querySelectorAll('.size-guide-section table:not([data-accessible-size-guide])');
  for (const [index, table] of [...tables].entries()) {
    const content = table.closest('rte-formatter,.size-guide-content');
    if (content && !content.hasAttribute('data-accessible-size-guide-outline')) {
      content.setAttribute('data-accessible-size-guide-outline', '');
      const level = content.matches('.size-guide-content') ? 3 : 2;
      for (const heading of content.querySelectorAll('h1,h2,h3,h4,h5,h6')) {
        if (!heading.textContent.trim()) heading.setAttribute('aria-hidden', 'true');
        else if (heading.matches('h1') || level === 3 && heading.matches('h3')) {
          // Merchant heading tags also set typography. Correct the outline
          // without replacing those tags or changing their visual styles.
          heading.setAttribute('role', 'heading');
          heading.setAttribute('aria-level', String(heading.matches('h1') ? level : level + 1));
        }
      }
    }
    const rows = [...table.rows].filter(row => row.cells.length);
    if (rows.length < 2) continue;
    const first = [...rows[0].cells];
    const measurementColumns = first[0].textContent.trim() === '' && first[1]?.textContent.trim() === '' ? 2 : 1;
    if (rows.some(row => row.cells.length !== first.length || [...row.cells].some(cell => cell.colSpan !== 1 || cell.rowSpan !== 1))) continue;
    table.dataset.accessibleSizeGuide = 'true';
    const prefix = `size-guide-${index}-${document.querySelectorAll('[data-accessible-size-guide]').length}`;
    const headings = [...document.querySelectorAll('main h1,main h2,main h3')]
      .filter(heading => heading.textContent.trim() && (heading.compareDocumentPosition(table) & Node.DOCUMENT_POSITION_FOLLOWING));
    const title = headings.at(-1)?.textContent.trim() || document.title;
    const caption = table.createCaption();
    caption.className = 'visually-hidden';
    caption.textContent = title;
    const sizeSystem = measurementColumns === 1 ? first[0].textContent.trim() : '';
    const columns = first.map((cell, column) => {
      const header = replaceWithHeader(cell, 'col', `${prefix}-col-${column}`);
      if (column < 2 && measurementColumns === 2) {
        // Preserve the compact, previously blank corner cells without losing their names.
        const label = document.createElement('span');
        label.className = 'visually-hidden';
        label.textContent = column === 0 ? 'Measurement' : 'Unit';
        header.replaceChildren(label);
      }
      if (column >= measurementColumns && sizeSystem) header.textContent = `${sizeSystem} ${header.textContent.trim()}`;
      return header;
    });
    let measurement = '';
    for (const [rowIndex, row] of rows.slice(1).entries()) {
      const cells = [...row.cells];
      measurement = cells[0].textContent.trim() || measurement;
      const unit = measurementColumns === 2 ? cells[1].textContent.trim() : '';
      const rowHeader = replaceWithHeader(cells[0], 'row', `${prefix}-row-${rowIndex}`);
      rowHeader.textContent = `${measurement}${unit ? ` ${unit}` : ''}`;
      if (measurement === 'CM') rowHeader.textContent = 'Centimeters (cm)';
      for (let column = measurementColumns; column < cells.length; column++) {
        cells[column].setAttribute('headers', `${columns[column].id} ${rowHeader.id}`);
      }
    }
  }
}

enhanceSizeGuides();
document.addEventListener('shopify:section:load', enhanceSizeGuides);

function labelFraudPreventionFrame(frame) {
  if (!frame) return;
  if (!frame.getAttribute('title')) frame.title = 'Fraud prevention';
}

labelFraudPreventionFrame(document.querySelector('iframe#ibody'));
// The app can replace its iframe after navigation or cart updates. Inspect
// inserted nodes only, avoiding a full-document lookup on every mutation.
const fraudFrameObserver = new MutationObserver(records => {
  for (const record of records) for (const node of record.addedNodes) {
    if (!(node instanceof Element)) continue;
    labelFraudPreventionFrame(node.matches('iframe#ibody') ? node : node.querySelector('iframe#ibody'));
  }
});
fraudFrameObserver.observe(document.body, { childList: true, subtree: true });
